
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Container, Row } from "reactstrap";
import { ThankYouRegisterTitle, ThankYouRegisterUser } from "../../utils/Constant";
import ThankYouRegisterTabs from "./ThankYouRegisterTabs";


const ThankYouRegisterContainer = () => {
  return (
    <>
      {/* Breadcrumbs (top navigation) */}
      <Breadcrumbs mainTitle={ThankYouRegisterTitle} parent={ThankYouRegisterUser} />

      {/* Page Container */}
      <Container fluid className="edit-profile">
        <Row>
          {/* Registration Form (Formik) */}
          <ThankYouRegisterTabs/>
        </Row>
      </Container>
    </>
  );
};

export default ThankYouRegisterContainer;
